<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important; font-weight: 400; color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;HR Reports</h5>
  </div>

  <div class="container">
    <div class="modal-body">

      <div class="row g-4">

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Diary Details')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="diaryDetailsClick()">Diary Details</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Penalty Summary')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="penaltySummaryClick()">Penalty Summary</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Availability')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="articleAvailabilityClick()">Article Availability</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article 1/6th Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="articleOneSixthClick()">Article 1/6th Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Employee Leave Summary')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="employeeLeaveSummaryClick()">Employee Leave Summary</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Empanelment Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="empanelmentReportClick()">Empanelment Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Overtime Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="overtimeReportClick()">Overtime Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Article Debit Credit Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="articleDebitCreditReportClick()">Article Debit Credit Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Salary Slip')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="salarySlipClick()">Salary Slip</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Announcement History')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="manageAnnouncementClick()">Announcement History</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Monthly New Joinee Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="manageMonthlyNewJoineeClick()">Monthly New Joinee Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Monthly Left Employee Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="manageEmployeeLeftReportClick()">Monthly Left Employee Report</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Monthly Conveyance Details')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="monthlyConveyanceDetailsClick()">Monthly Conveyance Details</div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Exit Form Summary')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="exitFormSummaryClick()">Exit Form Summary</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Latest CTC Details Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="latestCtcDetailsReportClick()">Latest CTC Details Report</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-4" *ngIf="hasAccess('Latest Reporting Partners Report')">
          <div class="card shadow mb-4" style="align-items: center;">
            <div class="card-body">
              <div style="color:#800000; text-decoration:underline; cursor:pointer; font-size:18px;"
                   (click)="latestReportingPartnersClick()">Latest Reporting Partners</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>